export default __webpack_public_path__ + "static/media/FSS_updated.1ba3549f.png";